import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Faq from 'components/Common/Faq'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { LOYALTY_CREDIT_CARD_LAYOUT_CONTAINER_CLASS } from './loyaltyCreditCardConstants'

const Section = styled(Pane)`
  padding: ${rem(40)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(60)} 0;
  }
`

function LoyaltyCreditCardFaqSection() {
  const intl = useIntl()

  return (
    <Section background="normal-background" id="faqs">
      <LayoutContainer className={LOYALTY_CREDIT_CARD_LAYOUT_CONTAINER_CLASS} variant="medium">
        <VerticalSpacer gap={24}>
          <Heading variant="heading3">
            {intl.formatMessage({
              id: 'JWBftlj_y0zF1HsEHhZu',
              defaultMessage: 'Frequently asked questions',
              description: 'Heading for the frequently asked questions section on the Société Credit Card page',
            })}
          </Heading>
          <Faq slug="societe-credit-card-faqs" />
        </VerticalSpacer>
      </LayoutContainer>
    </Section>
  )
}

export default LoyaltyCreditCardFaqSection
